module.exports = __webpack_public_path__ + "img/1525773041.9e6fa2ed.jpg";